import { getDefaultURLSearchRequest, URL_KEYS } from '@travel/traveler-core/utils/jrdpHelper';

import { fetchHotelList, fetchSEOData } from 'store/hotelList/actions';

import { fetchBanner } from 'store/banner/actions';

import { HOTEL_LIST_SORT } from 'constants/sort';
import { getDefaultURLCustomListRequest, getHotelListValidSortValue } from 'utils/search';

import type { URLSearchQuery } from 'Common-Types';
import type { universalRouterProps } from 'core/universalRouter/types';
import type { RequestBody } from 'HotelList-Types';
const DEFAULT_LIMIT = 30;

export type URLParams = { pageIdentifier: string; map?: string; pageNumber: number };

export default async (
  { store: { dispatch } }: universalRouterProps,
  params: URLParams,
  urlParams: URLSearchQuery,
) => {
  const sortKey =
    urlParams?.[URL_KEYS.SORT] === 'recommended'
      ? HOTEL_LIST_SORT.provider_recommend.value
      : urlParams?.[URL_KEYS.SORT];

  const query: RequestBody = {
    ...getDefaultURLSearchRequest(urlParams),
    ...getDefaultURLCustomListRequest(urlParams),
    accommodationArea: params.pageIdentifier,
    sort: getHotelListValidSortValue(sortKey),
    offset: (params.pageNumber - 1) * DEFAULT_LIMIT,
    limit: DEFAULT_LIMIT,
    latitude: urlParams?.latitude,
    longitude: urlParams?.longitude,
    zoomLevel: urlParams?.zoomLevel,
  };

  await Promise.all([dispatch(fetchBanner()), dispatch(fetchHotelList(query))]);

  return dispatch(fetchSEOData(params.pageNumber));
};
